import {get} from './index'

export function getHomeData(params) {
    return get('homePc',params);
}

export function getWorksData(params) {
    return get('works',params);
}

export function getWorksList(params) {
    return get('worksList',params)
}

export function getWorksDetail(params) {
    return get('works/'+params.id)
}

export function getUserData(params) {
    return get('user',params)
}
